import 'core-js'
import Vue from 'vue'
import App from './app.vue'

Vue.config.productionTip = false

import './style/index.less'
import iView from 'iview'
Vue.use(iView)

import Antd from 'ant-design-vue'
Vue.use(Antd)

import lodash from 'lodash'

// 引入网络请求和过滤器
import {filters, directives} from './libs'
lodash.mapKeys(filters, (fun, key) => Vue.filter(key, fun))
lodash.mapKeys(directives, (obj, key) => Vue.directive(key, obj))

// 引入注册全局组件
import * as GlobalComponents from '@/components/libs'
lodash.mapKeys(GlobalComponents, (obj, key) => Vue.component(key, obj))

// 配置路由
import router from './router'
import store from './modules'

new Vue({el: '#app', router: router, store: store, render: h => h(App)})
